<template>
	<vx-card no-shadow>
		<vs-prompt
			:title="$t('ExportAll')"
			class="export-options"
			@cancel="clearFields"
			@accept="exportToExcel"
			:accept-text="$t('ExportAll')"
			@close="clearFields"
			:active.sync="activePrompt"
		>
			<vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
			<v-select v-model="selectedFormat" :options="formats" class="my-4" />
			<div class="flex">
				<span class="mr-4">{{ $t("MapModule.CellAutoWith") }}:</span>
				<vs-switch v-model="cellAutoWidth">{{ $t("MapModule.CellAutoWith") }}</vs-switch>
			</div>
		</vs-prompt>
		<div class="export-table">
			<vs-table :data="dataEvents" v-model="selectedUsers" search>
				<template slot="thead">
					<vs-th> N.</vs-th>
					<vs-th> {{ $t("Activity.Activity") }}</vs-th>
					<vs-th> {{ $t("Date") }}</vs-th>
					<vs-th> {{ $t("Time") }}</vs-th>
					<vs-th v-show="!showMap"> {{ $t("Address") }}</vs-th>
					<vs-th v-show="showMap"> {{ $t("Actions") }}</vs-th>
				</template>
				<template slot-scope="{data}">
					<vs-tr
						:data="tr"
						:key="indextr"
						v-for="(tr, indextr) in data"
						:style="identifyRoutedEvents(tr.date_prog)"
					>
						<vs-td>{{ indextr + 1 }}</vs-td>
						<vs-td>{{ tr.activity_name | capitalize }}</vs-td>
						<vs-td>{{ tr.date_prog }}</vs-td>
						<vs-td>{{ hours(tr) }}</vs-td>
						<vs-td v-show="!showMap">{{ tr.address | capitalize }}</vs-td>
						<vs-td class="text-center" v-show="showMap">
							<div class="flex">
								<vs-button
									:title="$t('Crud.Delete')"
									v-if="tr.hasOwnProperty('point')"
									type="border"
									size="small"
									icon-pack="feather"
									icon="icon-trash"
									color="danger"
									class="mr-2"
									@click="deletePoint(tr)"
								></vs-button>
								<vs-button
									:title="$t('Locate')"
									type="border"
									size="small"
									icon-pack="feather"
									icon="icon-map-pin"
									color="success"
									class="mr-2"
									@click="handleSelected(tr)"
								></vs-button>
								<img
									v-if="tr.hasOwnProperty('point') && tr.point === 'start'"
									:src="startPoint"
									:alt="pointTitle(tr.point)"
									:title="pointTitle(tr.point)"
								/>
								<img
									v-if="tr.hasOwnProperty('point') && tr.point === 'final'"
									:src="finisPoint"
									:alt="pointTitle(tr.point)"
									:title="pointTitle(tr.point)"
								/>
							</div>
						</vs-td>
						<template slot="expand">
							<div class="con-expand-users w-full">
								<div class="con-btns-user flex items-center justify-between">
									<div class="con-userx flex items-center justify-start"></div>
									<div class="flex"></div>
								</div>
								<vs-list>
									<vs-list-header :title="$t('VisitPoint')" color="success"></vs-list-header>
									<vs-list-item
										icon-pack="feather"
										icon="icon-map"
										:title="`${$t('Address')}: ${tr.address}`"
									></vs-list-item>
									<vs-list-item
										v-if="tr.event_status_id"
										icon-pack="feather"
										icon="icon-map-pin"
										:title="$t('Name') + ': ' + tr.visit_point_name"
									>
									</vs-list-item>
									<vs-list-item
										v-if="tr.event_status_id"
										icon-pack="feather"
										icon="icon-map-pin"
										:title="$t('Identification') + ': ' + tr.visit_point_identification"
									>
									</vs-list-item>
									<vs-list-header :title="$t('Schedule.Visit')" color="success"></vs-list-header>
									<vs-list-item
										v-if="tr.event_status_id"
										icon-pack="feather"
										icon="icon-tag"
										:title="$t('Status')"
									>
										<vs-chip :color="chipColor(tr.event_status_id)"
											>{{ chipLabel(tr.event_status_id) }}
										</vs-chip>
									</vs-list-item>
								</vs-list>
							</div>
						</template>
					</vs-tr>
				</template>
			</vs-table>
		</div>
	</vx-card>
</template>

<script>
import vSelect from "vue-select";

export default {
	props: {
		deletePoint: {
			type: Function,
		},
		handleSelected: {
			type: Function,
		},
		currentDate: {
			type: String,
		},
	},
	components: {
		vSelect,
	},
	data() {
		return {
			fileName: "",
			formats: ["xlsx", "csv", "txt"],
			cellAutoWidth: true,
			selectedFormat: "xlsx",
			headerTitle: ["Id", "Punto de Visita", "Identificacion", "Direccion", "Hora Inicial", "Estado"],
			headerVal: [
				"id",
				"visit_point_name",
				"visit_point_identification",
				"address",
				"init_hour",
				"event_status_name",
			],
			selectedUsers: [],
			activePrompt: false,
			colors: {
				agendado: "#28C76F",
				reprogramado: "#006EFF",
				cancelado: "#FF0000",
				finalizado: "#19663b",
				en_proceso: "#FF9F43",
			},
			finisPoint: require("@/assets/images/markers/finish-flag.png"),
			startPoint: require("@/assets/images/markers/white-flag.png"),
		};
	},
	computed: {
		dataEvents() {
			return this.$store.state.moduleSchedule.events;
		},
		showMap() {
			return this.$store.state.moduleSchedule.showMap;
		},
		renderHours() {
			return function (params) {
				const {init_hour, end_hour} = params;
				return init_hour && end_hour;
			};
		},
		hours() {
			return function (params) {
				const {init_hour, end_hour} = params;
				return (init_hour || "") + " " + (end_hour || "");
			};
		},
		chipColor() {
			return (label) => {
				const chipColor = {
					1: this.colors["NOT_ASSIGNED"],
					2: this.colors["agendado"],
					3: this.colors["reprogramado"],
					4: this.colors["DELAYED"],
					5: this.colors["ON_THE_WAY"],
					6: this.colors["en_proceso"],
					7: this.colors["finalizado"],
					8: this.colors["cancelado"],
				};
				return chipColor[label] || this.colors["cancelado"];
			};
		},
		chipLabel() {
			return (label) => {
				const chipLabelTexts = {
					1: "NOT_ASSIGNED",
					2: "agendado",
					3: "reprogramado",
					4: "DELAYED",
					5: "ON_THE_WAY",
					6: "en_proceso",
					7: "finalizado",
					8: "cancelado",
				};
				return chipLabelTexts[label] || "cancelado";
			};
		},
		pointTitle() {
			return function (point) {
				return point === "start" ? this.$t("Routing.DeparturePoint") : this.$t("Routing.FinalPoint");
			};
		},
		identifyRoutedEvents() {
			return function (date_prog) {
				if (!date_prog) return;
				return {background: date_prog !== this.currentDate ? `rgba(var(--vs-${"warning"}),.25)` : ``};
			};
		},
	},
	methods: {
		showActivePrompt() {
			this.activePrompt = true;
		},
		exportToExcel() {
			import("@/vendor/Export2Excel").then((excel) => {
				const list = this.dataEvents;
				const data = this.formatJson(this.headerVal, list);
				excel.export_json_to_excel({
					header: this.headerTitle,
					data,
					filename: this.fileName,
					autoWidth: this.cellAutoWidth,
					bookType: this.selectedFormat,
				});
				this.clearFields();
			});
		},
		formatJson(filterVal, jsonData) {
			return jsonData.map((v) =>
				filterVal.map((j) => {
					return v[j];
				})
			);
		},
		clearFields() {
			this.fileName = "";
			this.cellAutoWidth = true;
			this.selectedFormat = "xlsx";
		},
	},
};
</script>
<style lang="scss" scoped>
.bg-agendado {
	background-color: #28c76f !important;
}

.bg-reprogramado {
	background-color: #006eff !important;
}

.bg-cancelado {
	background-color: #ff0000 !important;
}

.bg-finalizado {
	background-color: #19663b !important;
}

.bg-en_proceso {
	background-color: #ff9f43 !important;
}
</style>
